(function () {
  function initStickyPurchase() {
    const sticky = document.querySelector("[data-pdp-sticky-purchase]");
    const mainActions = document.querySelector(".kuuraii-proto .product-actions");
    if (!sticky || !mainActions) return;

    const stickyVariantInput = sticky.querySelector("[data-sticky-variant-input]");
    const stickyPrice = sticky.querySelector("[data-sticky-product-price]");
    const stickyButton = sticky.querySelector("[data-sticky-add-to-cart]");
    const stickyPreorderProperty = sticky.querySelector("[data-sticky-preorder-property]");

    document.querySelectorAll(".kuuraii-proto [data-variant-button]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (stickyVariantInput) stickyVariantInput.value = button.dataset.variantId || "";
        if (stickyPrice) stickyPrice.textContent = button.dataset.variantPrice || "";
        if (stickyButton) {
          const available = button.dataset.variantAvailable === "true";
          const preorder = button.dataset.variantPreorder === "true";
          stickyButton.disabled = !available && !preorder;
          stickyButton.textContent = preorder ? "Pre-order now" : available ? "Add to cart" : "Sold out";
          if (stickyPreorderProperty) {
            stickyPreorderProperty.disabled = !preorder;
          }
        }
      });
    });

    const observer = new IntersectionObserver(function (entries) {
      const entry = entries[0];
      const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle("is-visible", shouldShow);
      sticky.setAttribute("aria-hidden", String(!shouldShow));
    }, { threshold: 0.05 });

    observer.observe(mainActions);
  }

  function initCategoryStreams() {
    document.querySelectorAll("[data-category-stream-grid]").forEach(function (grid) {
      const cards = Array.from(grid.querySelectorAll("[data-category-stream-card]"));
      const sentinel = grid.parentElement.querySelector("[data-category-stream-sentinel]");
      if (!cards.length || !sentinel) return;

      const batchSize = window.matchMedia("(max-width: 749px)").matches ? 4 : 8;
      let visibleCount = 0;
      let observer = null;

      grid.classList.add("is-enhanced");
      cards.forEach(function (card) {
        card.hidden = true;
      });

      function revealNextBatch() {
        cards.slice(visibleCount, visibleCount + batchSize).forEach(function (card) {
          card.hidden = false;
        });
        visibleCount = Math.min(visibleCount + batchSize, cards.length);
        if (visibleCount >= cards.length) {
          sentinel.hidden = true;
          if (observer) observer.disconnect();
        }
      }

      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) revealNextBatch();
      }, { rootMargin: "320px 0px" });

      revealNextBatch();
      if (visibleCount < cards.length) observer.observe(sentinel);
    });
  }

  function initDetailReadMore() {
    document.querySelectorAll("[data-read-more]").forEach(function (container) {
      const copy = container.querySelector("[data-read-more-text]");
      const toggle = container.querySelector("[data-read-more-toggle]");
      if (!copy || !toggle) return;

      container.classList.add("is-enhanced");

      window.requestAnimationFrame(function () {
        if (copy.scrollHeight <= copy.clientHeight + 2) {
          container.classList.remove("is-enhanced");
          return;
        }

        toggle.addEventListener("click", function () {
          const expanded = container.classList.toggle("is-expanded");
          toggle.setAttribute("aria-expanded", String(expanded));
          toggle.textContent = expanded ? "Read less" : "Read more";
        });
      });
    });

    document.querySelectorAll("[data-detail-copy]").forEach(function (container) {
      const copy = container.querySelector("[data-detail-copy-text]");
      const toggle = container.querySelector("[data-detail-copy-toggle]");
      if (!copy || !toggle) return;

      const fullHeight = copy.scrollHeight;
      container.classList.add("is-enhanced");

      window.requestAnimationFrame(function () {
        if (fullHeight <= copy.clientHeight + 2) {
          container.classList.remove("is-enhanced");
          return;
        }

        toggle.addEventListener("click", function () {
          const expanded = container.classList.toggle("is-expanded");
          toggle.setAttribute("aria-expanded", String(expanded));
          toggle.textContent = expanded ? "Read less" : "Read more";
        });
      });
    });
  }

  function initMakingVideoControls() {
    document.querySelectorAll(".kuuraii-proto .making-video").forEach(function (wrap) {
      const video = wrap.querySelector("video");
      const button = wrap.querySelector("[data-making-video-play]");
      if (!video || !button) return;

      function setPlayingState(isPlaying) {
        wrap.classList.toggle("is-playing", isPlaying);
        button.setAttribute("aria-pressed", String(isPlaying));
        button.setAttribute("aria-label", isPlaying ? "Pause making video" : "Play making video");
      }

      button.addEventListener("click", function () {
        if (video.paused || video.ended) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function () {
              setPlayingState(false);
            });
          }
        } else {
          video.pause();
        }
      });

      video.addEventListener("play", function () {
        setPlayingState(true);
      });

      video.addEventListener("pause", function () {
        setPlayingState(false);
      });

      video.addEventListener("ended", function () {
        setPlayingState(false);
      });
    });
  }

  function init() {
    initStickyPurchase();
    initCategoryStreams();
    initDetailReadMore();
    initMakingVideoControls();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
